import { makeAutoObservable, reaction, runInAction } from 'mobx';
import { AuthenticatedUserModel } from '../../models/security/authenticatedUser';
import { ssoRequests } from '../../services/external/APIs';

export default class CommonStore {
    token: string | null = window.localStorage.getItem('jwt');
    user: AuthenticatedUserModel | null =
        window.localStorage.getItem('user') == null
            ? null
            : JSON.parse(window.localStorage.getItem('user') ?? '');
    isAuthenticated = false;
    appLoaded = false;

    constructor() {
        makeAutoObservable(this);
        reaction(
            () => this.token,
            (token) => {
                if (token) {
                    window.localStorage.setItem('jwt', token);
                } else {
                    window.localStorage.removeItem('jwt');
                }
            }
        );
    }

    setToken = (token: string | null) => {
        if (token) {
            this.token = token;
        }
    };

    setUser = (user: AuthenticatedUserModel | null) => {
        this.user = user;
    };

    setIsAuthenticated = (isAuthenticated: boolean) => {
        this.isAuthenticated = isAuthenticated;
    };

    setAppLoaded = () => {
        this.appLoaded = true;
    };

    getAuthenticatedUser = async (): Promise<AuthenticatedUserModel> => {
        if (!this.user) {
            await this.getUser();
            return this.user!;
        }
        return this.user;
    };

    getUser = async () => {
        try {
            ssoRequests.current().then((response) => {
                runInAction(() => (this.user = response.user));
            });
        } catch (error) {
            console.log(error);
        }
    };
}
